import script from "./accountSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./accountSetting.vue?vue&type=script&setup=true&lang=js"

import "./accountSetting.vue?vue&type=style&index=0&id=5e3937a2&lang=less"

const __exports__ = script;

export default __exports__